
const getStylesFromCssString = (cssString) => {
    const styleObject = {};
    if (cssString) {
        const styles = cssString.split(';').filter(s => s.trim() !== '');
        for (const style of styles) {
            const [property, value] = style.split(':').map(s => s.trim());
            const camelCaseProperty = property.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
            styleObject[camelCaseProperty] = value;
        }
    }
    return styleObject;
}

export default getStylesFromCssString;
